"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleCloseModal = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _modal = _interopRequireDefault(require("webmotors-react-pj/modal"));
var _button = _interopRequireDefault(require("webmotors-react-pj/button"));
var _style = require("webmotors-react-pj/frame/modal/menu/style");
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
const handleCloseModal = (tracking, onClose) => {
  (0, _v.default)(tracking, {
    site: {
      subEnvironment: 'homepage'
    },
    page: {
      flowType: 'cockpit',
      pageType: 'cockpit-homepage',
      pageName: '/webmotors/cockpit/homepage',
      'pageName.tier1': 'cockpit',
      'pageName.tier2': 'homepage',
      'pageName.tier3': undefined,
      loadTime: window.performance.timing.navigationStart
    }
  });
  onClose();
};
exports.handleCloseModal = handleCloseModal;
var _default = _ref => {
  let {
    onClose,
    params
  } = _ref;
  const {
    url
  } = params;
  const {
    target
  } = params.notification;
  const ModalsTypeObj = {
    "app": () => _react.default.createElement(_modal.default, {
      size: 'medium',
      onClose: () => handleCloseModal('pj_cockpit_fecharModalBaixarApp', onClose)
    }, _react.default.createElement(_style.StyleModalContainer, null, _react.default.createElement(_style.StyleLeftImage, {
      src: "/assets/img/icons/app-modal-ilustration.svg"
    }), _react.default.createElement(_style.StyleQRcodeAndText, null, _react.default.createElement("h2", null, _lang.default.global.modalAppDownloadTitle), _react.default.createElement("p", null, _lang.default.global.modalAppDownloadSubTitle1), _react.default.createElement("p", null, _lang.default.global.modalAppDownloadSubTitle2), _react.default.createElement(_style.StyleQRCodeImage, {
      src: "/assets/img/icons/app-modal-qr.svg"
    }), _react.default.createElement(_style.StyleButtonRedirect, null, _react.default.createElement(_button.default, {
      type: "button",
      token: "primary",
      onClick: () => window.location.href = url
    }, _lang.default.global.modalAppDownloadDownload)))))
  };
  return ModalsTypeObj[target]();
};
exports.default = _default;